export default "__VITE_ASSET__DncDBY3n__"